"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var createStorageHook_1 = __importDefault(require("../factory/createStorageHook"));
/**
 * Save a value on session storage
 */
var useSessionStorage = (0, createStorageHook_1["default"])('session');
exports["default"] = useSessionStorage;